<template>
  <div id="register_wrapper">
    <h1>请注册<span>欢迎注册会员！</span></h1>
    <!--左侧登录界面-->
    <div class="left">
      <Form
        ref="formCustom"
        :model="formCustom"
        :rules="ruleCustom"
        :label-width="120"
        autocomplete="off"
      >
        <FormItem
          label="用户名"
          prop="loginName"
        >
          <Input
            type="text"
            @input="fastInput"
            v-model.trim="formCustom.loginName"
            :maxlength="11"
            placeholder="手机号或数字或字母（6-11位）"
          ></Input>
        </FormItem>
        <FormItem
          label="手机号码"
          prop="phone"
        >
          <Select
            v-model="formCustom.phoneNum"
            @on-change="phoneNumChange"
            size="small"
            placeholder=""
            style="width:120px"
            :transfer="true"
          >
            <Option value="86">中国大陆+86</Option>
            <Option value="886">中国台湾+886</Option>
            <Option value="852">中国香港+852</Option>
            <Option value="853">中国澳门+853</Option>
          </Select>
          <Input
            style="width:200px"
            type="text"
            placeholder="请输入手机号码"
            :maxlength="phoneMaxLength"
            @input="fastInputPhone"
            v-model.number="formCustom.phone"
          ></Input>
          <div
            v-if="!showSec"
            class="getcode"
            style="cursor:pointer;"
            @click="phoneCode"
          >获取验证码</div>
          <div
            v-else
            class="seconds"
          >已发送 ({{seconds}}S)</div>
        </FormItem>
        <FormItem
          label="登录密码"
          prop="pwd"
        >
          <Input
            type="password"
            placeholder="请设置登录密码"
            v-model.trim="formCustom.pwd"
          ></Input>
        </FormItem>
        <FormItem
          label="验证码"
          prop="code"
        >
          <Input
            type="text"
            placeholder="请输入验证码"
            v-model.trim="formCustom.code"
          ></Input>
        </FormItem>
        <FormItem
          label="推荐人账号"
          class="recommend-item"
        >
          <!-- recommendLoginName -->
          <Input
            placeholder="请输入推荐人账号（非必填）"
            type="text"
            :disabled="recommendDisable"
            v-model.trim="formCustom.recommendLoginName"
            @on-blur="getNoLoginUserInfo"
          ></Input>
          <div
            class="recommend-name"
            v-if="recommendName"
          >{{recommendName}}</div>
          <div
            class="getcode"
            style="cursor:pointer;"
            @click="recommendEdit"
          >修改</div>
        </FormItem>
        <FormItem>
          <Checkbox
            v-model="formCustom.checked"
            size="large"
          ></Checkbox>
          <span style="font-size:14px">注册账号即表示您同意并愿意遵守开心云商<span
              style="cursor: pointer;color:#1F7BF5"
              @click="provisionHandle(1)"
            >用户协议</span>和<span
              style="cursor: pointer;color:#1F7BF5"
              @click="provisionHandle(2)"
            >隐私政策</span></span>
        </FormItem>
        <FormItem>
          <Button
            v-show="formCustom.checked"
            class="regis_ent m_register"
            type="primary"
            @click="handleSubmit('formCustom')"
          >注册新用户</Button>
          <Button
            style="width: 120px;height: 36px;display: flex;align-items: center;justify-content: center;font-size:14px"
            v-show="!formCustom.checked"
            disabled
            type="primary"
          >注册新用户</Button>
        </FormItem>

      </Form>

    </div>
    <!--左侧登录界面结束-->
    <!--中间竖线-->
    <div class="middle"></div>
    <!--中间竖线结束-->
    <!--右侧宣传-->
    <div class="right">
      <p>已有账号？请直接登录</p>
      <router-link
        to="/login"
        title="会员登录"
        class="regis_ent"
      >立即登录</router-link>
    </div>
    <div class="clearfix"></div>
    <!--右侧宣传结束-->
  </div>
</template>
<script>
import { getSession } from "utils/tool";
// import { getRegisterCode, userRegister } from "api/home";
import { getNoSettleCode, userNewRegister } from "api/order";
import { getNoLoginUserInfo } from "api/user";
import encrypt from "encryptlong";
export default {
  data() {
    const validateLoginName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("用户名不能为空"));
      } else {
        var rxNum = /^[a-zA-Z0-9]{6,11}$/;
        if (!rxNum.test(value)) {
          return callback(new Error("手机号或数字或字母，字数限制6-11位"));
        } else {
          callback();
          /* // 模拟异步验证效果
             setTimeout(() => {
             if (!value) {
             callback(new Error('Must be over 18 years of age'));
             } else {
             callback();
             }
             }, 1000);*/
        }
      }
    };

    const validateUserName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("会员姓名不能为空"));
      } else {
        var reg = /^[\u4e00-\u9fa5]{2,8}$/;
        if (!reg.test(value)) {
          return callback(new Error("姓名只能为2-8个汉字"));
        } else {
          callback();
          // 模拟异步验证效果
          /*setTimeout(() => {
             if (!value) {
             callback(new Error('会员名重复'));
             } else {
             callback();
             }
             }, 1000);*/
        }
      }
    };
    const validatePass = (rule, value, callback) => {
      if (!value || value === "") {
        callback(new Error("密码不能为空"));
      } else {
        var reg = /^.{6,}$/;
        if (!reg.test(value)) {
          return callback(new Error("最少6个字符"));
        }
        callback();
      }
    };
    const validatePwdCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再输入一次密码"));
      } else if (value !== this.formCustom.pwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    const validatePayPwd = (rule, value, callback) => {
      if (!value || value === "") {
        callback(new Error("支付密码不能为空"));
      } else {
        var reg = /^.{6,}$/;
        if (!reg.test(value)) {
          return callback(new Error("最少6个字符"));
        } else {
          callback();
        }
      }
    };
    const validatePayPwdCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再输入一次支付密码"));
      } else if (value !== this.formCustom.payPwd) {
        callback(new Error("两次输入支付密码不一致!"));
      } else {
        callback();
      }
    };
    const validatePhone = (rule, value, callback) => {
      if (!value || value === "") {
        callback(new Error("手机号不能为空"));
      } else {
        if (this.formCustom.phoneNum == 86 && !/^1[3-9]\d{9}$/.test(value)) {
          console.log(this.formCustom.phoneNum, 1);
          return callback(new Error("手机号格式错误"));
        } else if (
          this.formCustom.phoneNum == 852 &&
          !/^([5|6|9])\d{7}$/.test(value)
        ) {
          console.log(this.formCustom.phoneNum, 2);
          return callback(new Error("手机号格式错误"));
        } else if (this.formCustom.phoneNum == 853 && !/^6\d{7}/.test(value)) {
          console.log(this.formCustom.phoneNum, 3);
          return callback(new Error("手机号格式错误"));
        } else if (
          this.formCustom.phoneNum == 886 &&
          !/^[0][9]\d{8}/.test(value)
        ) {
          console.log(this.formCustom.phoneNum, 4);
          return callback(new Error("手机号格式错误"));
        } else if (this.clickGetPhone) {
          getNoSettleCode({
            phoneNumber:
              this.formCustom.phoneNum == 86
                ? value
                : "00" + this.formCustom.phoneNum + value,
            loginName: getSession("userName"),
            type: 1,
          }).then((res) => {
            this.clickGetPhone = false;
            this.showSec = true;
            this.countDown();
            if (res.resCode === 1) {
              this.$Message.success("已发送短信验证码");
              callback();
            } else {
              // 返回不成功
              callback(new Error(res.resDesc));
            }
          });
        } else {
          callback();
        }
      }
    };
    const validateCode = (rule, value, callback) => {
      if (!value || value === "") {
        callback(new Error("手机号验证码不能为空"));
      } else {
        var reg = /^.{4,}$/;
        if (!reg.test(value)) {
          return callback(new Error("最少4个字符"));
        } else {
          callback();
        }
      }
    };
    return {
      formCustom: {
        phoneNum: "",
        loginName: "",
        // userName: '',
        pwd: "",
        // pwdCheck: '',
        // payPwd: '',
        // payPwdCheck: '',
        phone: "",
        code: "",
        recommendLoginName: "",
        checked: true,
      },
      clickGetPhone: false,
      seconds: 60, //倒计时
      showSec: false,
      timer: undefined, //定时器id
      ruleCustom: {
        loginName: [{ validator: validateLoginName, trigger: "blur" }],
        userName: [{ validator: validateUserName, trigger: "blur" }],
        pwd: [{ validator: validatePass, trigger: "blur" }],
        pwdCheck: [{ validator: validatePwdCheck, trigger: "blur" }],
        payPwd: [{ validator: validatePayPwd, trigger: "blur" }],
        payPwdCheck: [{ validator: validatePayPwdCheck, trigger: "blur" }],
        phone: [{ validator: validatePhone, trigger: "blur" }],
        code: [{ validator: validateCode, trigger: "blur" }],
      },
      recommendDisable: false,
      recommendName: "",
    };
  },
  computed: {
    phoneMaxLength() {
      if (this.formCustom.phoneNum == 86) {
        return 11;
      } else if (this.formCustom.phoneNum == 886) {
        return 10;
      } else if (this.formCustom.phoneNum == 852) {
        return 8;
      } else {
        return 8;
      }
    },
  },
  watch: {
    $route: function () {
      if (this.$route.path == "/register") {
        this.handleReset("formCustom");
      }
    },
  },
  created() {
    this.formCustom.phoneNum = "86";
  },
  methods: {
    fastInputPhone(e) {
      this.$nextTick(() => {
        this.formCustom.phone = e.replace(/[^\d]/g, ""); // 多个空格保留一个空格
      });
    },

    fastInput(e) {
      this.$nextTick(() => {
        this.formCustom.loginName = e.replace(/[\W]/g, ""); // 多个空格保留一个空格
      });
    },

    phoneNumChange() {
      this.formCustom.phone = "";
    },
    btKeyDown(name) {
      this.formCustom.loginName = this.formCustom.loginName.replace(
        /[^\a-\z\A-\Z0-9]\_/g,
        ""
      );
    },
    //控制不能输入特殊字符
    btKeyUp(name) {
      this.formCustom.loginName = this.formCustom.loginName.replace(
        /[`~!@#$%^&*()\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g,
        ""
      );
    },
    // 服务条款
    provisionHandle(type) {
      if (type == 1) {
        this.$router.push({
          path: "/help",
          query: {
            articleid: 25,
          },
        });
      } else {
        this.$router.push({
          path: "/help",
          query: {
            articleid: 26,
          },
        });
      }
    },
    // 推荐人校验
    getNoLoginUserInfo() {
      if (this.formCustom.recommendLoginName) {
        getNoLoginUserInfo({
          loginName: this.formCustom.recommendLoginName,
        }).then((res) => {
          if (!res.data || !res.data.name) {
            this.formCustom.recommendLoginName = "";
            this.$Message.error("会员编号不存在");
          } else {
            this.recommendName = res.data.name;
            this.recommendDisable = true;
          }
        });
      }
    },
    // 点击修改推荐人
    recommendEdit() {
      this.recommendName = "";
      this.formCustom.recommendLoginName = "";
      this.recommendDisable = false;
    },
    phoneCode() {
      this.clickGetPhone = !!this.formCustom.phone;
      this.$refs.formCustom.validateField("phone");
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let _params = this.formCustom;
          let data = {
            loginName: _params.loginName,
            platform: "GD", //"0"：H5注册 "1"：非H5注册
            phoneNumber: _params.phone,
            onePwd: _params.pwd,
            code: _params.code,
            shareRegister: 0,
            recommendLoginName: this.formCustom.recommendLoginName,
          };
          const publicKey = process.env.PUBLICKEY;
          let encryptor = new encrypt();
          encryptor.setPublicKey(publicKey);
          let postBody = encryptor.encryptLong(JSON.stringify(data));
          userNewRegister(postBody).then((json) => {
            let users = {
              loginName: _params.loginName,
              password: _params.pwd,
            };
            if (json.resCode == 1) {
              this.$Message.success(json.resDesc);
              // 注册完成走登录逻辑
              this.$Loading.start();
              this.$store
                .dispatch(
                  "loginSystem",
                  this.$Rsa.encrypt(JSON.stringify(users))
                )
                .then((resp) => {
                  this.$Loading.finish();
                  if (resp.resCode === 0 || resp.data === null) {
                    this.$Message.error(resp.resDesc);
                  } else {
                    // 登录成功后获取用户登录状态
                    this.$store.dispatch("getSigned");
                    //登录成功后获取用户抽奖机会
                    //this.$store.dispatch('getLucky');
                    // 登录成功后获取用户购物车数据
                    this.$store.dispatch("getCartList");
                    //页面并跳转
                    this.$router.push({ path: "/" });
                  }
                })
                .catch(() => {
                  this.$Loading.error();
                  //          this.$Message.error(err)
                });
              // this.$router.push({
              //   path: "/login",
              // });
            } else {
              this.$Message.error(json.resDesc);
            }
          });
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    countDown() {
      const _this = this;
      this.timer = setInterval(function () {
        if (!_this.seconds) {
          clearInterval(_this.timer);
          _this.seconds = 60;
          _this.showSec = false;
          return;
        }
        _this.seconds -= 1;
      }, 1000);
    },
  },
  destroy() {
    clearInterval(this.timer);
  },
};
</script>
<style scoped lang="less">
.seconds {
  opacity: 0.8;
  cursor: not-allowed;
  padding: 0;
  margin: 0;
  height: 28px;
  line-height: 28px;
  width: 100px;
  border: medium none;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  outline: medium none;
  display: inline-block;
  font-size: 14px;
  border-radius: 4px;
  background: rgba(217, 163, 47, 0.7);
  color: #fff;
}
.recommend-item {
  position: relative;
}
.recommend-name {
  top: 3px;
  right: 245px;
  position: absolute;
  padding: 0 14px;
  margin: 0px;
  height: 28px;
  line-height: 28px;
  border: medium none;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  outline: medium none;
  display: inline-block;
  font-size: 14px;
  border-radius: 4px;
  background: #ccc;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// index.vue?775c1b8a